import { reversalSummary } from '../utils/invoiceReversal';
import type { AgreementInvoice } from '../types/agreements.types';

interface Props {
    invoice: AgreementInvoice;
    id?: string;
}

export function ReversedInvoiceDetails({ invoice, id }: Props) {
    return (
        <div id={id} className="space-y-1 border-t border-mp-border px-4 py-3 text-sm">
            <p className="font-medium text-mp-foreground">{reversalSummary(invoice)}</p>
            {invoice.reversalReason && <p className="whitespace-pre-line text-mp-muted">{invoice.reversalReason}</p>}
        </div>
    );
}
